import { render, staticRenderFns } from "./VerticalTable.vue?vue&type=template&id=a41cb7a0&scoped=true&"
import script from "./VerticalTable.vue?vue&type=script&lang=js&"
export * from "./VerticalTable.vue?vue&type=script&lang=js&"
import style0 from "./VerticalTable.vue?vue&type=style&index=0&id=a41cb7a0&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41cb7a0",
  null
  
)

export default component.exports